import classNames from 'classnames';
import { ReactNode } from 'react';
// import { Head } from '../head.component';
import { Breadcrumb } from './breadcrumb.component';

type LayoutProps = {
  title?: string;
  breadcrumb?: string;
  heading?: string;
  wrapperClass?: string;
  children: ReactNode;
  head?: ReactNode;
};

export const Layout = ({
  title,
  breadcrumb,
  heading,
  wrapperClass,
  head,
  children,
}: LayoutProps) => {
  return (
    <>
      {/* <Head {...{ title }}>{head}</Head> */}
      <section
        className={classNames(wrapperClass ? wrapperClass : 'main-homepage')}
      >
        {breadcrumb && <Breadcrumb {...{ breadcrumb, heading }} />}
        {children}
      </section>
    </>
  );
};
